import React, { useState } from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import {
	validateEmail,
	validateFistName,
	validateLastName,
	// validatePassword,
	// validateUsername,
	// AppString,
	// validateConfirmPassword,
	toastSuccessHelper,
} from '@utils';
import { Button, CustomInput, CustomSpinner } from '@components';
import { registerUser } from '@services';

interface HandleSignUpPopupProps {
	closeModal: () => void;
	modelref: React.RefObject<HTMLDivElement>;
}

export const SignupScreen: React.FC<HandleSignUpPopupProps> = ({
	closeModal,
	modelref,
}) => {
	// State variables
	const [fistName, setFistname] = useState<string>('');
	const [lastName, setLastName] = useState<string>('');
	const [email, setEmail] = useState<string>('');
	// const [username, setUsername] = useState<string>('');
	// const [password, setPassword] = useState<string>('');
	// const [confirmPassword, setConfirmPassword] = useState<string>('');

	// Error states
	const [fistnameError, setFistnameError] = useState<string>('');
	const [lastNameError, setlastNameError] = useState<string>('');
	const [emailError, setEmailError] = useState<string>('');
	const [responseError, setResponseError] = useState<string>('');
	const [lodder, setLodder] = useState<boolean>(false);
	// const [usernameError, setUsernameError] = useState<string>('');
	// const [passwordError, setPasswordError] = useState<string>('');
	// const [confirmPasswordError, setConfirmPasswordError] = useState<string>('');

	const validateField = (
		value: string,
		validationFunc: (value: string) => string,
		setError: React.Dispatch<React.SetStateAction<string>>
	) => {
		const error = validationFunc(value);
		setError(error);
		return !error;
	};

	const validateForm = () => {
		const isEmailValid = validateField(email, validateEmail, setEmailError);
		// const isUsernameValid = validateField(
		// 	username,
		// 	validateUsername,
		// 	setUsernameError
		// );
		// const isPasswordValid = validateField(
		// 	password,
		// 	validatePassword,
		// 	setPasswordError
		// );
		// const isConfirmPasswordValid = validateField(
		// 	confirmPassword,
		// 	(value) => validateConfirmPassword(password, value),
		// 	setConfirmPasswordError
		// );
		const isFistnameValid = validateField(
			fistName,
			validateFistName,
			setFistnameError
		);
		const islastnameValid = validateField(
			lastName,
			validateLastName,
			setlastNameError
		);

		return (
			// isUsernameValid &&
			// isPasswordValid &&
			// isConfirmPasswordValid &&
			isEmailValid && isFistnameValid && islastnameValid
		);
	};

	const handleSubmit = async () => {
		if (validateForm()) {
			setLodder(true);
			try {
				const response = await registerUser({ email, fistName, lastName });
				if (response.status === 200) {
					toastSuccessHelper(
						'Your account has been successfully created! A password has been sent to your registered email.'
					);
					closeModal();
				}
			} catch (e: any) {
				setResponseError(e?.response?.data?.message || 'Something went wrong');
			}
			setLodder(false);
		}
	};
	return (
		<div className="fixed inset-0 z-[100] flex items-center justify-center overflow-y-auto bg-black bg-opacity-50">
			<div className="min-h-screen w-full py-8 px-4 flex items-center justify-center">
				<div
					ref={modelref}
					className="relative w-[90%] max-w-[500px] bg-white shadow-custom rounded overflow-y-auto max-h-[calc(100vh-50px)] [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] md:px-4"
				>
					{/* Header - Fixed at top */}
					<div className=" bg-white border-b">
						<div className="flex justify-between items-center p-4">
							<h2 className="font-semibold text-[22px]">
								Sign up for an account
							</h2>
							<button onClick={closeModal}>
								<IoCloseSharp className="w-5 h-5 font-bold" />
							</button>
						</div>
					</div>

					{/* Scrollable Content */}
					<div className="">
						<div className=" text-[10px]  md:text-sm px-4 pt-4">
							<p className="mb-2">
								An account allows you to bookmark properties, save custom
								searches, and set up notifications for new data results.
							</p>
							<p className="mb-4">
								To create an account, enter the following information:
							</p>
						</div>

						{responseError && (
							<div>
								<p className="text-red-600 font-semibold text-[14px] text-center">
									{responseError}
								</p>
							</div>
						)}
						<div className="px-4 mb-4">
							<CustomInput
								label="Email Address*"
								type="email"
								labelClassName="font-semibold"
								placeHolder={''}
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								error={emailError}
							/>
							<div className="text-[12px] text-[#818181] mt-1">
								<p>Please use your organizations email, if applicable.</p>
							</div>

							{/* <CustomInput
								label="Username *"
								type="text"
								labelClassName="font-semibold"
								placeHolder={''}
								value={username}
								onChange={(e) => setUsername(e.target.value)}
								error={usernameError}
							/> */}

							{/* <CustomInput
								label="Password"
								type="password"
								labelClassName="mt-4 font-semibold"
								placeHolder={''}
								value={password}
								onChange={(e) => setPassword(e.target.value)}
								error={passwordError}
							/> */}

							{/* <CustomInput
								label={AppString.confirm_password}
								type="password"
								labelClassName="font-semibold mt-4"
								placeHolder={AppString.confirm_password}
								value={confirmPassword}
								onChange={(e) => setConfirmPassword(e.target.value)}
								error={confirmPasswordError}
							/> */}

							<CustomInput
								label="First name *"
								type="text"
								placeHolder={''}
								value={fistName}
								labelClassName="font-semibold mt-2"
								onChange={(e) => setFistname(e.target.value)}
								error={fistnameError}
							/>

							<CustomInput
								label="Last name *"
								type="text"
								labelClassName="font-semibold mt-2"
								placeHolder={''}
								value={lastName}
								onChange={(e) => setLastName(e.target.value)}
								error={lastNameError}
							/>
						</div>
					</div>

					{/* Footer - Fixed at bottom */}
					<div className="sticky bottom-0 bg-white border-t px-4 py-4 z-10">
						<Button
							title="Submit"
							onPress={handleSubmit}
							styleDiv="self-center w-full text-center btn-dark p-2 rounded-sm cursor-pointer"
						/>
					</div>
				</div>
			</div>

			{lodder && (
				<div className="absolute inset-0 flex items-center h-full justify-center bg-black bg-opacity-30">
					<CustomSpinner width={100} height={100} border={10} />
				</div>
			)}
		</div>
	);
};
